export default {
    data() {
        return {
            openText: window.Drupal.t('Open today:'),
            closedText: window.Drupal.t('Closed'),
        }
    },

    computed: {
        isOpen() {
            if (!this.marker.opening_hours) {
                return false;
            }

            return this.marker.opening_hours.isOpen;
        },

        currentSlot() {
            if (!this.marker.opening_hours) {
                return false;
            }

            let activeDay = _.find(this.marker.opening_hours.days, (day) => {
                return day.active === true;
            });

            if (_.isEmpty(activeDay.slots)) {
                return false;
            }

            return `${_.first(activeDay.slots).open} - ${_.last(activeDay.slots).closed}`;
        }
    }
}